module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia2-b876580c8576f70d61a6395014deeabd.jpg";